<h1 mat-dialog-title>Excluir</h1>
<div mat-dialog-content>{{ data.message }}</div>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">CANCELAR</button>
  <button mat-button [mat-dialog-close]="true" color="warn">CONFIRMAR</button>
</mat-dialog-actions>
